<div
  class="content"
  role="menu"
  coinKeyboardMenuNavigation="[role='menuitem']"
  [navigationRows]="3"
  (closeMenu)="appsClosed.emit($event)">
  <!-- Overview -->
  <button
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.overview' | translate"
    [attr.aria-label]="'main-menu.overview' | translate"
    (click)="openApp('')">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.overview', icon: 'dashboard' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Allocation -->
  <button
    permissionAccess
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.allocation' | translate"
    [attr.aria-label]="'main-menu.allocation' | translate"
    [allowedResources]="[permissionResource.Allocation]"
    (click)="openApp('/budget-allocation')">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.allocation', icon: 'supervisor_account' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Support Apps -->
  <button
    permissionAccess
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.support-apps' | translate"
    [attr.aria-label]="'main-menu.support-apps' | translate"
    [allowedResources]="[
      permissionResource.AllocationHR,
      permissionResource.ReOrganisationApp,
      permissionResource.PositionEvaluationHR,
      permissionResource.OrganisationManagementAdmin,
      permissionResource.OrganisationPlanningAdmin,
      permissionResource.SuccessionManagementAdmin,
      permissionResource.SuccessionManagementHR,
      permissionResource.IncentiveSeasonHr
    ]"
    (click)="openApp('/support-apps')">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.support-apps', icon: 'recent_actors' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Special Payment -->
  <button
    *permissions="{ allowedResources: [permissionResource.SpecialPayment], directAllowAccess: isLineManager() }"
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.special-payment' | translate"
    [attr.aria-label]="'main-menu.special-payment' | translate"
    (click)="openApp('/special-recognition')">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.special-payment', icon: 'diamond' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Mercer -->
  @if (isMercerAccessAllowed$ | async) {
    <button
      class="no-style coin-app"
      role="menuitem"
      [matTooltip]="'main-menu.mercer' | translate"
      [attr.aria-label]="'main-menu.mercer' | translate"
      (click)="openApp('/mercer')">
      <coin-siemens-energy-coin-app
        [app]="{ name: 'main-menu.mercer', icon: 'account_tree' }"></coin-siemens-energy-coin-app>
    </button>
  }

  <!-- Organisation Planning -->
  <button
    permissionAccess
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.organisation-planning' | translate"
    [attr.aria-label]="'main-menu.organisation-planning' | translate"
    [allowedResources]="[permissionResource.OrganisationPlanning, permissionResource.OrganisationPlanningAdmin]"
    (click)="openApp('/org-planning')">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.organisation-planning', icon: 'hub' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Organisation Management -->
  <ng-container *featureFlag="'orgManagement'">
    <button
      permissionAccess
      class="no-style coin-app"
      role="menuitem"
      [matTooltip]="'main-menu.organisation-management' | translate"
      [attr.aria-label]="'main-menu.organisation-management' | translate"
      [allowedResources]="[
        permissionResource.OrganisationManagementUser,
        permissionResource.OrganisationManagementAdmin
      ]"
      (click)="openApp('/org-management')">
      <coin-siemens-energy-coin-app
        [app]="{ name: 'main-menu.organisation-management', icon: 'corporate_fare' }"></coin-siemens-energy-coin-app>
    </button>
  </ng-container>

  <!-- Headcount | People Planner -->
  <ng-container>
    <button
      *permissions="{
        allowedResources: [
          permissionResource.CAndB,
          permissionResource.HeadcountApprovalHr,
          permissionResource.HeadcountApprovalAdmin,
          permissionResource.HeadcountApprovalUser,
          permissionResource.HeadcountController
        ],
        directAllowAccess: isHead() || isLineManager()
      }"
      class="no-style coin-app"
      role="menuitem"
      [matTooltip]="'main-menu.headcount-approval' | translate"
      [attr.aria-label]="'main-menu.headcount-approval' | translate"
      (click)="openApp('/people-planner')">
      <coin-siemens-energy-coin-app
        [app]="{ name: 'main-menu.headcount-approval', icon: 'badge' }"></coin-siemens-energy-coin-app>
    </button>
  </ng-container>

  <!-- ECL -->
  <button
    permissionAccess
    class="no-style coin-app"
    role="menuitem"
    [allowedResources]="[
      permissionResource.EmploymentConditionLibraryUser,
      permissionResource.EmploymentConditionLibraryAdmin,
      permissionResource.EmploymentConditionLibraryRestricted,
      permissionResource.EmploymentConditionLibraryGenerator
    ]"
    [matTooltip]="'main-menu.ecl' | translate"
    [attr.aria-label]="'main-menu.ecl' | translate"
    (click)="openApp('/ecl')">
    <coin-siemens-energy-coin-app [app]="{ name: 'main-menu.ecl', icon: 'description' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- My Profile -->
  @if (!isDeputy()) {
    <button
      class="no-style coin-app"
      role="menuitem"
      [matTooltip]="'main-menu.my-profile' | translate"
      [attr.aria-label]="'main-menu.my-profile' | translate"
      (click)="openApp('/employee-detail-overview')">
      <coin-siemens-energy-coin-app
        [app]="{ name: 'main-menu.my-profile', icon: 'person' }"></coin-siemens-energy-coin-app>
    </button>
  }

  <!-- Document Center -->
  <ng-container *featureFlag="'documentCenter'">
    @if (!isDeputy()) {
      <button
        class="no-style coin-app"
        role="menuitem"
        [matTooltip]="'main-menu.document-center' | translate"
        [attr.aria-label]="'main-menu.document-center' | translate"
        (click)="openApp('/document-center')">
        <coin-siemens-energy-coin-app
          [app]="{ name: 'main-menu.document-center', icon: 'how_to_vote' }"></coin-siemens-energy-coin-app>
      </button>
    }
  </ng-container>

  <!-- Analytics -->
  <button
    permissionAccess
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.analytics' | translate"
    [attr.aria-label]="'main-menu.analytics' | translate"
    [allowedResources]="[permissionResource.Analytics]"
    (click)="openPage(analyticsUrl)">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.analytics', icon: 'analytics' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Admin -->
  <button
    permissionAccess
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.admin' | translate"
    [attr.aria-label]="'main-menu.admin' | translate"
    [allowedResources]="[permissionResource.AdminApp]"
    (click)="openAdminFrontend()">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.admin', icon: 'exit_to_app' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Equity -->
  <button
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.equity' | translate"
    [attr.aria-label]="'main-menu.equity' | translate"
    (click)="openApp('/equity')">
    <coin-siemens-energy-coin-app [app]="{ name: 'main-menu.equity', icon: 'insights' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Incentive -->
  <button
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.incentive' | translate"
    [attr.aria-label]="'main-menu.incentive' | translate"
    (click)="openApp('/incentive')">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.incentive', icon: 'timeline' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- G2M -->
  <button
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.g2m' | translate"
    [attr.aria-label]="'main-menu.g2m' | translate"
    (click)="openApp('/G2M')">
    <coin-siemens-energy-coin-app
      [app]="{ name: 'main-menu.g2m', icon: 'library_books' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Merit -->
  <button
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.merit' | translate"
    [attr.aria-label]="'main-menu.merit' | translate"
    (click)="openApp('/merit')">
    <coin-siemens-energy-coin-app [app]="{ name: 'main-menu.merit', icon: 'bar_chart' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Star -->
  <button
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.star' | translate"
    [attr.aria-label]="'main-menu.star' | translate"
    (click)="openApp('/star')">
    <coin-siemens-energy-coin-app [app]="{ name: 'main-menu.star', icon: 'star' }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Succession Management -->
  <button
    *permissions="{ allowedResources: [permissionResource.All], directAllowAccess: isLineManager() }"
    class="no-style coin-app"
    role="menuitem"
    [matTooltip]="'main-menu.succession-management' | translate"
    [attr.aria-label]="'main-menu.succession-management' | translate"
    (click)="openApp('/succession-management')">
    <coin-siemens-energy-coin-app
      [app]="{
        name: 'main-menu.succession-management',
        icon: 'switch_access_shortcut'
      }"></coin-siemens-energy-coin-app>
  </button>

  <!-- Restructuring -->
  <ng-container *featureFlag="'restructuring'">
    <button
      permissionAccess
      class="no-style coin-app"
      role="menuitem"
      [allowedResources]="[
        permissionResource.RestructuringHr,
        permissionResource.RestructuringAdmin,
        permissionResource.RestructuringAdminRestricted,
        permissionResource.RestructuringConditionLibraryAdmin
      ]"
      [matTooltip]="'main-menu.restructuring' | translate"
      [attr.aria-label]="'main-menu.restructuring' | translate"
      (click)="openApp('/restructuring')">
      <coin-siemens-energy-coin-app
        [app]="{ name: 'main-menu.restructuring', icon: 'account_tree' }"></coin-siemens-energy-coin-app>
    </button>
  </ng-container>

  <ng-container>
    <button
      class="no-style coin-app"
      role="menuitem"
      [matTooltip]="'main-menu.cosmos' | translate"
      [attr.aria-label]="'main-menu.cosmos' | translate"
      (click)="openApp('/', appType.cosmos)">
      <coin-siemens-energy-coin-app [app]="{ name: 'main-menu.cosmos', icon: 'public' }"></coin-siemens-energy-coin-app>
    </button>
  </ng-container>
</div>
